
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AssignedProcedureDTO, ProcedureDTO, SpecialityImageDTO } from '../Models/Procedure.model';
import { SpecialityDTO, SpecialityMappingDTO } from '../Models/Speciality.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import {environment} from '../../environments/environment';
declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-user-speciality',
  templateUrl: './user-speciality.component.html',
  styleUrls: ['./user-speciality.component.scss'],
  providers: [SrubUpService, CookieService]
})
export class UserSpecialityComponent implements OnInit {
  public baseurl: string = environment.base_url;
  myspecialities:any=[];
  defaultSpecialities:any=[];
  moreSpecialities:any=[];
  zeroMySpecialities: boolean;
  setAssignProcedures: boolean;
  isSpecialityAlreadyAdded: boolean;
  selectedSpecialityIdToAdd: number;
  selectedSpeciality: SpecialityDTO;
  getAdminValues: boolean;
  imageUploadApiUrlLength: number;
  isImpersonateMode: boolean;
  specialityName: string;
  description: string;
  imagePath: string;

  index: boolean;
  edit: boolean;
  universalHideAndShowMpId;
  mpId: number;
  public loading = false;
  nextButtonDisabled: boolean;

  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  iValue: number;
  uploadUrl: string;
  Headers: any;
  specialityId: number;
  procedures: Array<ProcedureDTO>;
  mySpecialities: Array<SpecialityDTO>;

  specialities: Array<SpecialityDTO>;
  activeSpecialityIds: Array<number>;
  isMySpeciality: Array<SpecialityMappingDTO>;
  assignedProcedures: Array<ProcedureDTO>;
  assignedProcedureId: number;
  assignedProcedureIds: Array<string>;
  toAssignProcedures: Array<ProcedureDTO>;
  toAssignprocedure: AssignedProcedureDTO;
  loginUserId: number;

  tempUrl: Array<string>;
  isLoading: boolean;

  specialityImagesList: Array<SpecialityImageDTO>;
  loadingBase64: string;

  constructor(private router: Router, private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.zeroMySpecialities = false;
    this.getAdminValues = false;
    this.isLoading = true;

    this.specialityImagesList = new Array<SpecialityImageDTO>();

    Globals.ImpersonationValue = JSON.parse(this.cookieService.get('impersonation'));
    this.isImpersonateMode = Globals.ImpersonationValue;
   // alert(this.isImpersonateMode);
    //console.log(this.isImpersonateMode);
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.isSpecialityAlreadyAdded = false;
    this.setAssignProcedures = false;
    this.tempUrl = new Array<string>();
    this.specialityId = 0;
    this.selectedSpecialityIdToAdd = 0;
    this.specialities = new Array<SpecialityDTO>();
    this.mySpecialities = new Array<SpecialityDTO>();

    this.isMySpeciality = new Array<SpecialityMappingDTO>();

    this.assignedProcedures = new Array<ProcedureDTO>();
    this.toAssignProcedures = new Array<ProcedureDTO>();
    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    this.nextButtonDisabled = true;
    this.index = true;

    this.invisible = 0;
    this.editvisi = 0;
    this.showEditingDiv = -1;
    this.iValue = -1;

    this.procedures = new Array<ProcedureDTO>();
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
  }

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  IsSubscribedSpeciality(specialityId) {
    var speciality = this.specialities.find(x => x.ID == specialityId);
    if (speciality != undefined && speciality != null) {
      return speciality.IsActive;
    }
    else {
      return false;
    }
  }

  IsActiveSpeciality(specialityId) {
    var speciality = this.specialities.find(x => x.ID == specialityId);
    if (speciality != undefined && speciality != null) {
      return !speciality.IsExpired;
    }
    else {
      return false;
    }
  }

  UserClick(btnCount) {
    this.edit = false;

    if (btnCount == 1) {
      this.specialityName = "";
      this.description = "";
      this.imagePath = "";
      this.specialityId = 0;
      this.edit = true;
      this.showEditingDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.specialityName = "";
      this.description = "";
    }
  }

  specialitySelectedToAdd(specialityName) {

    swal({
      title: 'Please Subscribe.',
      type: 'info',
      timer: 2000,
      showConfirmButton: false
    }).catch(swal.noop);
  }

  showProcedures(SpecialityID,Name,userSpecialityID) {
    // if (this.findObjectByKey(this.specialities, 'Name', specialityName).IsExpired == true) {
    //   swal({
    //     title: 'Your Subscription has expired',
    //     type: 'info',
    //     timer: 2000,
    //     showConfirmButton: false
    //   }).catch(swal.noop);
    //   return;
    // }
    //this.specialityId = this.findObjectByKey(this.specialities, 'Name', specialityName).ID;

    Globals.SpecialityId = SpecialityID;
    Globals.SpecialityName = Name;
    Globals.userSpecialityId = userSpecialityID;
    this.cookieService.set("specialityId", Globals.SpecialityId.toString());
    this.cookieService.set("userSpecialityId", Globals.userSpecialityId.toString());
    this.cookieService.set("specialityName", Globals.SpecialityName.toString());
    this.router.navigateByUrl("/layout/user-procedure");
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId, true).subscribe(ab => {
        this.specialities.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });
    });
  }

  getMoreSpecialities()
  {
    this.moreSpecialities=[];
    this.scrubUpService.getDefaultSpecialities(this.token).subscribe(x => { // to get specialities based on user id
      //console.log(x['Data']['DefaultSpeciality']);
     //let morespeciality:any=[];
      if (x['Data']['DefaultSpeciality'] != null && x['Data']['DefaultSpeciality']!= undefined) {
        this.defaultSpecialities = x['Data']['DefaultSpeciality'];
        //console.log(this.defaultSpecialities);

        for(var j=0;j<this.defaultSpecialities.length;j++)
        {
          let doesexist=false;
          for(var i=0;i<this.myspecialities.length;i++)
          {
            if(this.defaultSpecialities[j]['SpecialityID']==this.myspecialities[i]['SpecialityID'])
            {
              doesexist=true;

            }

          }
          if(!doesexist)
          {
            this.moreSpecialities.push(this.defaultSpecialities[j]);
          }
          this.loading = false;
        }
      // console.log(this.moreSpecialities);
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });
  }


  GetSpecialities() {
    this.myspecialities =[];
    this.specialities =[]
    this.loading = true;

    this.scrubUpService.GetSpecialities(this.token, this.loginUserId, this.getAdminValues).subscribe(x => { // to get specialities based on user id

      if (x['Data'] != null && x['Data']!= undefined) {
        this.loading = false;
        this.specialities = x['Data'];
       this.myspecialities = x['Data'];

      //   for (var i=0;i<this.specialities.length;i++)
      //   {
      // this.myspecialities.push(this.specialities[i]['SpecialityID']);
      //   }
       // console.log(this.specialities);

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });
  }

  ngOnInit() {
    this.GetSpecialities();
    this.getMoreSpecialities();
    $('.wizard-card').bootstrapWizard({
      'tabClass': 'nav nav-pills',
      'nextSelector': '.btn-next',
      'previousSelector': '.btn-previous',

      onNext: (tab, navigation, index) => {
        //const $valid = $('.wizard-card form').valid();

        return true;
      },

      onInit: function (tab: any, navigation: any, index: any) {

        // check number of tabs and fill the entire row
        let $total = navigation.find('li').length;
        let $wizard = navigation.closest('.wizard-card');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.wizard-card .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {

        // if (this.currentTab === 1 && index == 0) {
        //     if (this.form1Valid) {
        //         //this.currentTab = index;
        //         this.currentTab++;
        //         return true;
        //     }
        // }
        // if (this.currentTab === 2 && index == 1) {
        //     if (this.form2Valid) {
        //         //this.currentTab = index;
        //         this.currentTab++;
        //         return true;
        //     }
        // }
        // if (this.currentTab > 2 && index == 2) {
        //     this.currentTab--;
        //     this.form2Valid = false;
        //     return true;
        // }

        return true;
      },

      onTabShow: (tab: any, navigation: any, index: any) => {
        let $total = navigation.find('li').length;
        let $current = index + 1;
        const $wizard = navigation.closest('.wizard-card');

        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        }
        else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            'opacity': '0',
            'visibility': 'hidden',
            'position': 'absolute'
          });
        } else {
          $(checkbox).css({
            'opacity': '1',
            'visibility': 'visible'
          });
        }
        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
      }
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');
  }

  ngAfterViewInit() {
    $('.wizard-card').each(function () {

      const $wizard = $(this);
      const index = $wizard.bootstrapWizard('currentIndex');
      let $total = $wizard.find('.nav li').length;
      let $li_width = 100 / $total;

      let total_steps = $wizard.find('.nav li').length;
      let move_distance = $wizard.width() / total_steps;
      let index_temp = index;
      let vertical_level = 0;

      let mobile_device = $(document).width() < 600 && $total > 3;

      if (mobile_device) {
        move_distance = $wizard.width() / 2;
        index_temp = index % 2;
        $li_width = 50;
      }

      $wizard.find('.nav li').css('width', $li_width + '%');

      let step_width = move_distance;
      move_distance = move_distance * index_temp;

      let $current = index + 1;

      if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
        move_distance -= 8;
      } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
        move_distance += 8;
      }

      if (mobile_device) {
        let x: any = index / 2;
        vertical_level = parseInt(x);
        vertical_level = vertical_level * 38;
      }

      $wizard.find('.moving-tab').css('width', step_width);
      $('.moving-tab').css({
        'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
        'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
      });

      $('.moving-tab').css({
        'transition': 'transform 0s'
      });
    });
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/user-speciality/user-speciality.component.ts